import { useCallback, useEffect, useState } from "react";
import { getTimeDistance, getTimeDistanceDigits, getUTCTime } from "./utils";

export interface TimeLeftState {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  expired: boolean;
}

const initialTimeLeftState: TimeLeftState = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  expired: true,
};

export interface UseCountdownTimerProps {
  date: string;
  time?: string;
}

export function useCountdownTimer(props: UseCountdownTimerProps) {
  const { date, time = "00:00" } = props;
  const targetTime = getUTCTime(date, time);

  const [timeLeft, setTimeLeft] = useState<TimeLeftState>({
    ...initialTimeLeftState,
    expired: targetTime - Date.now() < 0,
  });

  const updateTimer = useCallback(
    (intervalID: number) => {
      const distance = getTimeDistance(targetTime);

      if (distance < 0) {
        window.clearInterval(intervalID);
        setTimeLeft(initialTimeLeftState);
      } else {
        setTimeLeft({ ...getTimeDistanceDigits(distance), expired: false });
      }
    },
    [targetTime],
  );

  useEffect(() => {
    let intervalID: number;

    if (!timeLeft.expired) {
      intervalID = window.setInterval(() => updateTimer(intervalID), 1000);
    }

    return () => {
      if (intervalID) {
        window.clearInterval(intervalID);
      }
    };
  }, [targetTime, timeLeft.expired, updateTimer]);

  return timeLeft;
}
